import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@nymbl/nos2-rules";
import { CalendarPanel, type PanelMemory } from "@/components/calendar/CalendarPanel";
import { formatWeekRange } from "@/lib/time/dates";

interface CalendarSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** The Sunday of the week the Time page shows. */
  weekStart: string;
  /** The Time page's Accept entry ids (see `CalendarPanel`). */
  entryIds: Map<string, string>;
  memory: PanelMemory;
}

/**
 * The Time page's From calendar sheet: the shown week's meetings to accept, beside the grid
 * rather than above it, so the week stays at the top of the page.
 */
export function CalendarSheet({
  open,
  onOpenChange,
  weekStart,
  entryIds,
  memory,
}: CalendarSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full overflow-y-auto sm:max-w-3xl lg:max-w-5xl">
        <SheetHeader>
          <SheetTitle className="font-display text-xl">From your calendar</SheetTitle>
          <SheetDescription>{formatWeekRange(weekStart)}</SheetDescription>
        </SheetHeader>
        <div className="px-4 pb-6">
          {open && <CalendarPanel weekStart={weekStart} entryIds={entryIds} memory={memory} />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
